module.exports = __webpack_public_path__ + "media/images/landing_page/seedlings-f2f3ec34d98848ab37d4cbfae50c134f.jpg";